import Pure from './pure';

const FeaturesOverview = Pure;

export default FeaturesOverview;